import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import ukTranslations from './locales/uk.json';
import roTranslations from './locales/ro.json';
import { getLanguageFromRegion } from './lib/getLanguageFromRegion';

const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    try {
      const stored = localStorage.getItem('i18nextLng');
      if (stored) {
        return stored;
      }
    } catch {
      // localStorage may be unavailable in private browsing mode.
    }
  }

  return getLanguageFromRegion();
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      uk: {
        translation: ukTranslations,
      },
      ro: {
        translation: roTranslations,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

export default i18n;
